// Shared "should we offer to install the PWA" checks — used by the manual
// Settings install card and the automatic post-registration/post-payment popup.

export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false
  const nav = window.navigator as Navigator & { standalone?: boolean }
  return Boolean(window.matchMedia?.('(display-mode: standalone)').matches || nav.standalone === true)
}

export function isMobileDevice(): boolean {
  return typeof window !== 'undefined' && Boolean(window.matchMedia?.('(pointer: coarse)').matches)
}
